import request from "@/utils/request";

export function getCategoryList(params, headers) {
  return request({
    url: "/api/mts-api/goods/category/list",
    method: "get",
    params: params,
    headers,
  });
}
export function getModelList(params) {
  return request({
    url: "/api/mts-api/goods/model/list",
    method: "get",
    params: params,
  });
}

export function getBrandList(params) {
  return request({
    url: "/api/mts-api/goods/brand/list",
    method: "get",
    params: params,
  });
}

export function getHomeBrand(params) {
  return request({
    url: "/api/mts-api/goods/brand/home",
    method: "get",
    params: params,
  });
}

// 品牌入驻
export function joinBrand(data) {
  return request({
    url: "/api/mts-api/goods/brand/join",
    method: "post",
    data,
  });
}

// 品牌认领
export function addBrandSupplier(data) {
  return request({
    url: "/api/mts-api/goods/brand/addSupplier",
    method: "post",
    data,
  });
}

export function getBrandDetail(params) {
  return request({
    url: "/api/mts-api/goods/brand/detail",
    method: "get",
    params: params,
  });
}

export function getTypeList() {
  return request({
    url: "/api/mts-api/goods/type/list",
    method: "get",
  });
}

export function getModelSearch(params) {
  return request({
    url: "/api/mts-api/goods/model/search",
    method: "get",
    params: params,
  });
}
export function getBrandSearch(params) {
  return request({
    url: "/api/mts-api/goods/brand/search",
    method: "get",
    params: params,
    // 品牌联想随输入触发，不显示遮挡表单的全局加载提示。
    skipLoading: true,
  });
}
export function getTypeSearch(params) {
  return request({
    url: "/api/mts-api/goods/type/search",
    method: "get",
    params: params,
  });
}

export function getCategoryAttributeList(params) {
  return request({
    url: "/api/mts-api/goods/category/attribute_list",
    method: "get",
    params: params,
  });
}

// 查询分类属性值详情
export function getCategoryAttributeValue(params) {
  return request({
    url: "/api/mts-api/goods/attribute_value_list",
    method: "get",
    params: params,
  });
}

// 查询分类属性
export function getCategoryAttribute(params) {
  return request({
    url: "/api/mts-api/goods/goods_category/attribute",
    method: "get",
    params: params,
  });
}
